import React, { useEffect, useState } from 'react'
import PanelTitle from 'app/main/subscribersV4/subscriberDetail/PanelTitle'
import {
  always,
  compose,
  ifElse,
  isNil,
  prop,
  propEq,
  find,
  mergeRight,
  propOr,
  filter,
  length,
  gt,
} from 'ramda'
import {
  Chip,
  Divider,
  Tab,
  Box,
  makeStyles,
  useMediaQuery,
} from '@material-ui/core'
import { FormattedMessage, useIntl } from 'react-intl'
import { TabContext, TabList, TabPanel } from '@material-ui/lab'
import { useDispatch } from 'react-redux'
import { useAppName } from 'commons/usePartner'
import { channelName } from 'app/componentV4/Channel/ChannelsName'

import useQuickInfo, {
  tabs,
  tabIds,
} from 'app/main/subscribersV4/subscriberDetail/useQuickInfo'
import ChannelIcon from 'app/componentV4/Channel/ChannelIcon'
import SelectGroup from 'app/main/subscribersV4/SelectGroup'
import SelectTopics from 'app/main/subscribersV4/subscriberDetail/SelectTopics'
import StarBorderIcon from '@material-ui/icons/StarBorder'
import { PersonAddIcon } from 'app/components/icons'
import ImageProfileOrCharacter from '../ImageProfileOrCharacter'
import clsx from 'clsx'
import { CHANNEL_APP } from 'app/constants/channel'
import StatusChip from 'app/componentV4/Status/Chip'
import { subscriberStatus } from 'app/constants/subscriberCRM'
import SubscriberAction from 'app/main/subscribersV4/actions/SubscriberAction'
import { AccessType } from 'app/auth/accessControlService'
import AccessControl from 'app/auth/AccessControl'
import ContainedButton from 'app/componentV4/Button/ContainedButton'
import { SECONDARY, CANCEL } from 'app/constants/button'
import ComposeMessageIcon from 'app/components/icons/ComposeMessageIcon'
import ProfileDetailTab from 'app/main/subscribersV4/subscriberDetail/profiles/ProfileDetailTab'
import AccountInfoTab from 'app/main/subscribersV4/subscriberDetail/accounts/AccountInfoTab'
import { TYPE_SUBSCRIBERS } from 'app/constants/subscriberCRM'
import { openDialog } from 'app/auth/store/actions/createNotification.actions'
import { ACTION_NEW, GENERAL_DIALOG } from 'app/constants/compose'
import MessageAlert from 'app/components/MessageAlert'
import { useFormContext } from './FormProvider'
import {
  openWarningDialog,
  closeWarningDialog,
} from 'app/store/actions/warningDialog.actions'
import TruncatedText from 'app/componentV4/TruncatedText'
import EditIcon from '@material-ui/icons/Edit'
import HowToRegIcon from '@material-ui/icons/HowToReg'
import { Icon } from '@material-ui/core'
import Assets from 'app/configs/assetConfigs'

import { isEmptyOrNil } from 'libs/empty'
import { getHumanizeDate } from 'commons/date'
import { useTheme } from '@material-ui/core/styles'
import effects from 'app/effects/effects'
import { compressImage } from 'libs/compressImage'
import { MAX_FILE_SIZE } from 'app/main/composeMessage/socials/useSocialMediaSetting'
import ActivityLogTab from './activitys/ActivityLogTab'
import { Routes } from 'app/services/routeService/routeService'
import useSubscribers from '../useSubscribers'
import { usePlace } from 'commons/usePlace'
import useFeatureFlag from 'app/configs/useFeatureFlag'
import {
  PLACE_INVITATION_ACCEPT_REQUEST,
  PLACE_INVITATION_DECLINED,
  PLACE_INVITATION_UNVERIFIED,
} from 'app/configs/statusConfigs'
import { fileToBase64 } from 'libs/file'

const imageMaxSize = MAX_FILE_SIZE * 1024 * 1024

const useStyles = makeStyles(() => ({
  tabContext: {
    '& .MuiTabs-indicator': {
      backgroundColor: '#646464 !important',
    },
  },
  tabList: {
    '& .MuiTabs-flexContainer': {
      overflowY: 'auto',
    },
  },
}))

const SubscriberPanel = (props) => {
  const {
    subscriber,
    refetchData,
    history,
    languages,
    countries,
    onLoading,
    isLoading,
  } = props
  const place = usePlace()
  const theme = useTheme()
  const isDownXs = useMediaQuery(theme.breakpoints.down('xs'))
  const [nextLocation, setNextLocation] = useState(null)
  const [imageLoading, setImageLoading] = useState(false)
  const [confirmNavigation, setConfirmNavigation] = useState(false)

  const dispatch = useDispatch()
  const classes = useStyles()
  const {
    generalDirty,
    contactDirty,
    addressDirty,
    employerDirty,
    socialDirty,
    onAllFormReset,
  } = useFormContext()
  const { formatMessage } = useIntl()
  const {
    state: {
      isOpenGropSelector,
      tagSelected,
      topicsSelector,
      isOpenTopicsSelector,
      tab,
      isTopicSubmitting,
      isGroupSubmitting,
    },
    onSetDefaultGroupAndTopics,
    onOpenGroupSelector,
    onCloseGroupSelector,
    onGroupSelectorConfirm,
    onOpenTopicsSelector,
    onCloseTopicsSelector,
    onTopicsSelectorConfirm,
    toggleTab,
  } = useQuickInfo({ commonDispatch: dispatch, formatMessage })

  const {
    handleDeleteSubscriber,
    handleInviteSubscriber,
    handlePendingApproveSubscriber,
    handleMarkCorrect,
  } = useSubscribers()

  const appName = useAppName()

  const hideContacts = prop('hideContacts', subscriber)

  const isBadContact = compose(
    gt(0),
    length,
    filter((item) => {
      return item.isBadContact
    }),
    prop('receiveMethods'),
  )(subscriber)

  const preferredChannel = ifElse(
    isNil,
    always(CHANNEL_APP),
    compose(
      prop('channel'),
      find(propEq('isSelected', 1)),
      prop('receiveMethods'),
    ),
  )(subscriber)

  const menuItems = [
    {
      icon: <Icon className="text-blue-primary">check_circle</Icon>,
      label: formatMessage({ id: 'subscriber.approve.button.label' }),
      onClick: () => console.log('Approve clicked'),
    },
    {
      icon: <EditIcon className="text-blue-primary" />,
      label: formatMessage({ id: 'action.update' }),
      onClick: () => console.log('Edit clicked'),
    },
    {
      icon: <HowToRegIcon className="text-blue-primary" />,
      label: formatMessage({ id: 'action.markAsCorrect' }),
      onClick: () => console.log('Mark as correct clicked'),
    },
    {
      icon: Assets.deleteOutline,
      label: formatMessage({ id: 'action.delete' }),
      textColor: 'text-watermelon',
      isImage: true,
      onClick: () => console.log('Delete clicked'),
    },
  ]

  const onChangeTab = (tab, newValue) => {
    if (
      generalDirty ||
      contactDirty ||
      addressDirty ||
      employerDirty ||
      socialDirty
    ) {
      const payload = {
        title: formatMessage({ id: 'dialog.leave.title' }),
        description: formatMessage({ id: 'dialog.leave.body' }),
        submitText: formatMessage({
          id: 'leave.label',
        }),
        closeText: formatMessage({ id: 'dialog.discard.close' }),
        type: CANCEL,
        onSubmit: () => {
          onAllFormReset()
          dispatch(closeWarningDialog())
          setTimeout(() => {
            toggleTab(tab, newValue)
          }, 200)
        },
        onClose: () => {
          dispatch(closeWarningDialog())
        },
      }
      dispatch(openWarningDialog(payload))
    } else {
      toggleTab(tab, newValue)
    }
  }

  const handleImageChange = async (event) => {
    setImageLoading(true)
    const file = event.target.files[0]
    if (!isNil(file)) {
      const overMaxSize = file.size >= imageMaxSize

      if (overMaxSize) {
        dispatch(
          MessageAlert.showError({
            message: formatMessage(
              { id: 'froala.text.error.filesize' },
              { maxSize: MAX_FILE_SIZE },
            ),
          }),
        )
        return
      }

      const fileCompress = await compressImage(file)
      const fileBase64 = await fileToBase64(fileCompress)

      effects.apis
        .uploadImageFileForCrm({
          subscriberId: subscriber.id,
          file: fileBase64,
        })
        .then((response) => {
          refetchData(prop('id', subscriber))
        })
        .catch((e) => {
          setImageLoading(false)
          dispatch(
            MessageAlert.showError({
              message: formatMessage({
                id: 'createNotification.media.multipleImage.upload.failed',
              }),
            }),
          )
        })
    }
  }

  const onRefetchForm = (subscriberId) => {
    refetchData(subscriberId)
    onAllFormReset()
  }

  const openComposeDialog = () => {
    dispatch(
      openDialog({
        initialValues: {
          subscribers: [
            mergeRight(subscriber, {
              type: TYPE_SUBSCRIBERS,
              name: `${subscriber.firstName} ${subscriber.lastName}`,
            }),
          ],
        },
        onCreateSuccess: () => {
          dispatch(
            MessageAlert.showSuccess({
              message: formatMessage({
                id: 'createNotification.success.message',
              }),
            }),
          )
        },
        type: GENERAL_DIALOG,
        action: ACTION_NEW,
      }),
    )
  }

  const handleClickOpenComposeDialog = () => {
    if (
      generalDirty ||
      contactDirty ||
      addressDirty ||
      employerDirty ||
      socialDirty
    ) {
      const payload = {
        title: formatMessage({ id: 'dialog.leave.title' }),
        description: formatMessage({ id: 'dialog.leave.body' }),
        submitText: formatMessage({
          id: 'leave.label',
        }),
        closeText: formatMessage({ id: 'dialog.discard.close' }),
        type: CANCEL,
        onSubmit: () => {
          openComposeDialog()
          onAllFormReset()
          dispatch(closeWarningDialog())
        },
        onClose: () => {
          dispatch(closeWarningDialog())
        },
      }
      dispatch(openWarningDialog(payload))
    } else {
      openComposeDialog()
    }
  }

  const backToSubscribers = () => {
    props.history.push(Routes.subscribersV4())
  }

  const onReloadData = () => {
    refetchData(subscriber.id)
  }

  useEffect(() => {
    onSetDefaultGroupAndTopics(subscriber)
  }, [])

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (
        (event.key === 'F5' ||
          (event.ctrlKey && event.key === 'r') ||
          (event.metaKey && event.key === 'r')) &&
        (generalDirty ||
          contactDirty ||
          addressDirty ||
          employerDirty ||
          socialDirty)
      ) {
        event.preventDefault()
        event.stopPropagation()
        showCustomDialog()
      }
    }

    const handleBeforeUnload = (event) => {
      if (
        generalDirty ||
        contactDirty ||
        addressDirty ||
        employerDirty ||
        socialDirty
      ) {
        event.preventDefault()
        showCustomDialog()
      }
    }

    const showCustomDialog = () => {
      const payload = {
        title: formatMessage({ id: 'dialog.leave.title' }),
        description: formatMessage({ id: 'dialog.leave.body' }),
        submitText: formatMessage({ id: 'leave.label' }),
        closeText: formatMessage({ id: 'dialog.discard.close' }),
        type: CANCEL,
        onSubmit: () => {
          onAllFormReset()
          dispatch(closeWarningDialog())
          setTimeout(() => {
            window.location.reload()
          }, 100)
        },
        onClose: () => {
          dispatch(closeWarningDialog())
        },
      }
      dispatch(openWarningDialog(payload))
    }

    window.addEventListener('keydown', handleKeyDown)
    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [generalDirty, contactDirty, addressDirty, employerDirty, socialDirty])

  useEffect(() => {
    if (confirmNavigation && nextLocation) {
      const unblock = history.block(() => {})
      history.push(nextLocation.pathname)
      unblock()
    }
  }, [confirmNavigation, nextLocation, history])

  useEffect(() => {
    const unblock = history.block((nextLoc) => {
      if (
        generalDirty ||
        contactDirty ||
        addressDirty ||
        employerDirty ||
        socialDirty
      ) {
        setNextLocation(nextLoc)

        const payload = {
          title: formatMessage({ id: 'dialog.leave.title' }),
          description: formatMessage({ id: 'dialog.leave.body' }),
          submitText: formatMessage({ id: 'leave.label' }),
          closeText: formatMessage({ id: 'dialog.discard.close' }),
          type: CANCEL,
          onSubmit: () => {
            setConfirmNavigation(true)
            dispatch(closeWarningDialog())
          },
          onClose: () => {
            setNextLocation(null)
            dispatch(closeWarningDialog())
          },
        }

        dispatch(openWarningDialog(payload))

        return false
      }

      return true
    })

    return () => {
      unblock()
    }
  }, [
    history,
    generalDirty,
    contactDirty,
    addressDirty,
    employerDirty,
    socialDirty,
    dispatch,
  ])

  useEffect(() => {
    setTimeout(() => {
      setImageLoading(false)
    }, 300)
  }, [subscriber.avatar])

  return (
    <div className="p-5 sm:p-24 h-full overflow-y-auto">
      <div className="w-full space-y-5 md:space-y-0 md:flex justify-between space-y-3">
        <div className="flex items-center">
          <PanelTitle {...props} />
        </div>
      </div>
      <div className="my-5">
        <div className={clsx('space-y-10', classes.tabContext)}>
          <div className="bg-white rounded-lg shadow p-5 sm:p-10 max-w-full">
            <div className="sm:flex justify-between sm:space-y-0 space-y-5">
              <div className="flex">
                <div className="w-60 h-64 rounded-lg flex justify-center items-center">
                  <ImageProfileOrCharacter
                    placeHolder={prop('avatarCharacters', subscriber)}
                    subscriberId={prop('id', subscriber)}
                    alt={[
                      prop('firstName', subscriber),
                      prop('middleName', subscriber),
                      prop('lastName', subscriber),
                    ].join(' ')}
                    src={prop('avatar', subscriber)}
                    isLoading={imageLoading}
                    onImageSelected={handleImageChange}
                    isEditImage={true}
                  />
                </div>
                <div
                  className={clsx(
                    'flex flex-col px-5',
                    isDownXs && 'w-5/6 flex-1',
                  )}
                >
                  <div className="flex-1 bg-blue-500 text-14 font-bold text-neutrals-800">
                    <TruncatedText
                      text={[
                        prop('firstName', subscriber),
                        prop('middleName', subscriber),
                        prop('lastName', subscriber),
                      ].join(' ')}
                      maxLength={isDownXs ? 35 : 40}
                    />
                  </div>

                  <div className="flex-1 flex align-autoplay text-12 text-neutrals-500">
                    <FormattedMessage
                      id="subscriberDetail.lastSeenDate.label"
                      values={{
                        date: isEmptyOrNil(subscriber.lastSeenDate)
                          ? '--'
                          : getHumanizeDate(subscriber.lastSeenDate),
                      }}
                    />
                  </div>
                  <div className="py-2 flex space-x-2">
                    <Chip
                      label={channelName(preferredChannel, appName)}
                      variant="outlined"
                      icon={
                        <div className="h-auto flex h-10">
                          <ChannelIcon channel={preferredChannel} size={14} />
                        </div>
                      }
                      className="w-auto bg-primary-200 text-primary-300 border-primary-350 text-12 h-10"
                    />
                    {!isNil(prop('lastInvitationStatus', subscriber)) && (
                      <StatusChip
                        type={
                          subscriberStatus[subscriber.lastInvitationStatus].type
                        }
                        label={formatMessage({
                          id: subscriberStatus[subscriber.lastInvitationStatus]
                            .label,
                        })}
                        className="h-10"
                      />
                    )}
                    {isBadContact && (
                      <Chip
                        label={formatMessage({
                          id: 'subscriber.filter.invalid',
                        })}
                        variant="outlined"
                        className="border-1 border-orange-200 text-orange-600 bg-orange-50 h-10"
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="flex h-40">
                <AccessControl
                  accesses={[
                    AccessType.NOTIFICATION_SEND,
                    AccessType.ADMINISTRATION,
                  ]}
                >
                  <ContainedButton
                    color={SECONDARY}
                    className="h-36 mx-2 m-auto w-full"
                    onClick={handleClickOpenComposeDialog}
                  >
                    <div className="flex space-x-2 items-center">
                      <ComposeMessageIcon />
                      <span className="w-full">
                        {formatMessage({
                          id: 'action.compose.message',
                        })}
                      </span>
                    </div>
                  </ContainedButton>
                </AccessControl>
                {!isNil(prop('lastInvitationStatus', subscriber)) && (
                  <div className="m-auto flex-1">
                    <SubscriberAction
                      subscriberId={subscriber.id}
                      channel={preferredChannel}
                      hasBadContact={subscriber.hasBadContact}
                      status={subscriber.lastInvitationStatus}
                      isHorizontal={true}
                      handleInvite={() =>
                        handleInviteSubscriber({ ids: [subscriber.id] })
                      }
                      handleReInvite={() =>
                        handleInviteSubscriber({ ids: [subscriber.id] })
                      }
                      handleDelete={() => {
                        onLoading()
                        handleDeleteSubscriber(
                          { ids: [subscriber.id] },
                          backToSubscribers,
                        )
                      }}
                      handleApprove={() =>
                        handlePendingApproveSubscriber(
                          {
                            ids: [subscriber.id],
                            placeId: place.id,
                            status: PLACE_INVITATION_UNVERIFIED,
                          },
                          onReloadData,
                        )
                      }
                      handleReject={() =>
                        handlePendingApproveSubscriber(
                          {
                            ids: [subscriber.id],
                            placeId: place.id,
                            status: PLACE_INVITATION_DECLINED,
                          },
                          onReloadData,
                        )
                      }
                      handleMarkCorrect={() => {
                        onLoading()
                        handleMarkCorrect({ subscriberId: subscriber.id }, () =>
                          onReloadData(subscriber.id),
                        )
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="mt-10">
              <div className="sm:flex sm:space-y-0 space-y-10">
                <div className="flex flex-col space-y-2">
                  <div className="flex space-x-2 text-neutrals-500">
                    <PersonAddIcon classes="text-neutrals-500" />
                    <span className="text-16">
                      <FormattedMessage id="subscriber.label.groups" />
                    </span>
                  </div>
                  <div>
                    <div
                      className="text-blue-950 underline cursor-pointer"
                      onClick={onOpenGroupSelector}
                    >
                      <FormattedMessage
                        id="subscriberCrm.count.groups"
                        values={{ count: tagSelected.length }}
                      />
                    </div>
                    <SelectGroup
                      open={isOpenGropSelector}
                      value={tagSelected}
                      isSubmitting={isGroupSubmitting}
                      onConfirm={(groups) =>
                        onGroupSelectorConfirm({
                          subscriberId: subscriber.id,
                          groups,
                        })
                      }
                      onCloseDialog={onCloseGroupSelector}
                    />
                  </div>
                </div>
                <Divider
                  orientation="vertical"
                  style={{ margin: '0 15px' }}
                  flexItem
                />
                <div className="flex flex-col space-y-2">
                  <div className="flex space-x-2 text-neutrals-500">
                    <StarBorderIcon
                      fontSize="small"
                      className="text-neutrals-500"
                    />
                    <span className="text-16">
                      <FormattedMessage id="notifications.topics.label" />
                    </span>
                  </div>
                  <div>
                    <div
                      className="text-blue-950 underline cursor-pointer"
                      onClick={onOpenTopicsSelector}
                    >
                      <FormattedMessage
                        id="subscriberCrm.count.topics"
                        values={{ count: topicsSelector.length }}
                      />
                    </div>
                    <SelectTopics
                      open={isOpenTopicsSelector}
                      value={topicsSelector}
                      isSubmitting={isTopicSubmitting}
                      onConfirm={(topicIds) =>
                        onTopicsSelectorConfirm({
                          subscriberId: subscriber.id,
                          topicIds,
                        })
                      }
                      onCloseDialog={onCloseTopicsSelector}
                    />
                  </div>
                </div>

                {/* It have to change in the feture? */}
                {/* <Divider
                  orientation="vertical"
                  style={{ margin: '0 15px' }}
                  flexItem
                />
                <div className="flex flex-col space-y-2">
                  <div className="flex  space-x-2 text-neutrals-500">
                    <MailOutlineIcon
                      fontSize="small"
                      className="text-neutrals-500 w-16"
                    />
                    <span className="text-16">
                      <FormattedMessage id="email.address.label" />
                    </span>
                  </div>
                  <div className="break-words">
                    <div className="text-blue-950">
                      {isDownXs && !hideContacts ? (
                        propOr('--', 'email', subscriber)
                      ) : (
                        <TruncatedText
                          text={
                            hideContacts
                              ? formatMessage({ id: 'restricted.label' })
                              : propOr('--', 'email', subscriber)
                          }
                          maxLength={40}
                        />
                      )}
                    </div>
                  </div>
                </div>

                <Divider
                  orientation="vertical"
                  style={{ margin: '0 15px' }}
                  flexItem
                />
                <div className="flex flex-col space-y-2">
                  <div className="flex space-x-2 text-neutrals-500">
                    <SmartphoneIcon
                      fontSize="small"
                      className="text-neutrals-500"
                    />
                    <span className="text-16">
                      <FormattedMessage id="subscriber.label.phoneNumber" />
                    </span>
                  </div>
                  <div>
                    <div className="text-blue-950">
                      {hideContacts
                        ? formatMessage({ id: 'restricted.label' })
                        : `${propOr('-', 'countryCode', subscriber) || ''}${propOr('-', 'phoneNumber', subscriber)}`}
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <TabContext value={tab}>
            <Box sx={{ borderBottom: 1, borderColor: '#646464' }}>
              <TabList
                className={clsx(
                  'border-b-1 border-grey-input',
                  classes.tabList,
                )}
                onChange={onChangeTab}
                aria-label="Tabs of subscriber detail"
              >
                {tabs.map((item) => {
                  return (
                    <Tab
                      className={clsx(
                        'capitalize text-16 px-10',
                        item.id === tab
                          ? 'text-blue-950 font-medium'
                          : 'text-gray-400 font-normal',
                      )}
                      label={formatMessage({ id: item.labelId })}
                      value={item.id}
                      key={`subscriber-detail-${item.id}`}
                    />
                  )
                })}
              </TabList>
            </Box>
            <TabPanel className="p-0" value={tabIds.profile}>
              <ProfileDetailTab
                subscriber={subscriber}
                subscriberId={subscriber.id}
                refetchData={onRefetchForm}
                isLoading={isLoading}
                languages={languages}
                countries={countries}
              />
            </TabPanel>
            <TabPanel className="p-0" value={tabIds.account}>
              <AccountInfoTab subscriber={subscriber} languages={languages} />
            </TabPanel>
            <TabPanel className="p-0" value={tabIds.membership}>
              Content for Tab 3
            </TabPanel>
            <TabPanel className="p-0" value={tabIds.activity}>
              <ActivityLogTab subscriberId={subscriber.id} />
            </TabPanel>
          </TabContext>
        </div>
      </div>
    </div>
  )
}

export default SubscriberPanel
